import React from 'react';

/**
 * DidMount like hook effect
 *
 * @export
 */
export function useDidMount() {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    window.requestAnimationFrame(() => setMounted(true));
  }, []);

  return { mounted };
}